module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-15.ca52ceeb.png";